import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { AvailableFeature } from 'src/app/core/services/user-profile.service';

@Component({
    selector: 'app-header-search',
    templateUrl: './header-search.component.html',
    styleUrls: ['./header-search.component.scss'],
    standalone: false
})
export class HeaderSearchComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  openSearchInputTimerId: number | null = null;

  /**
   * Whether the search input is expanded or not.
   */
  visible = false;

  AvailableFeature = AvailableFeature;

  @Input() searchValue: string;

  @Output() searchValueChange = new EventEmitter<string>();

  public constructor(
    private readonly elementRef: ElementRef
  ) {}

  public ngOnInit() {
    // If the search input has a value, show it from start.
    this.visible = this.searchValue ? this.searchValue.length > 0 : false;
    window.addEventListener('click', this.onWindowClick);
  }

  public ngOnDestroy() {
    window.removeEventListener('click', this.onWindowClick);
    this.clearOpenSearchInputTimer();
  }

  openSearch(_: MouseEvent) {
    /**
     * If the search input is already visible, there's no need to trigger the
     * open search input process again, to avoid undesired focusing of the input.
     */
    if(this.visible) {
      return;
    }

    this.visible = true;

    // Clear previous timer if any.
    this.clearOpenSearchInputTimer();

    // Wait a bit in order to auto focus the input.
    this.openSearchInputTimerId = (
      window.setTimeout(() => {
        // If the search input is not available, there's no need to focus it.
        if(!this.searchInput) {
          return;
        }
        this.searchInput.nativeElement.focus();
      }, 200)
    )
  }

  closeSearch() {
    // Do not allow to close the search input if there's a value.
    if(this.searchValue.trim().length) {
      return;
    }
    this.visible = false;
    this.clearOpenSearchInputTimer();
  }

  onKeyUp(e: KeyboardEvent) {
    if(e.key === 'Escape') {
      // TODO: Change this behavior to maybe clear the search before? Since it's currently not possible to close the search input if there is something typed to the input.
      // this.closeSearch();
    }
  }

  onSearchChange(e: Event) {
    if(!(e.target instanceof HTMLInputElement)) {
      return;
    }
    this.searchValueChange.emit(e.target.value);
  }

  private onWindowClick = (e: MouseEvent) => {
    // If the user clicks out of the search input, close it.
    if (this.visible && !this.elementRef.nativeElement.contains(e.target)) {
      this.closeSearch();
    }
  };

  private clearOpenSearchInputTimer() {
    if(this.openSearchInputTimerId !== null) {
      clearTimeout(this.openSearchInputTimerId);
      this.openSearchInputTimerId = null;
    }
  }
}
